(function($) {
    $(document).ready(function() {
        const fishingContent = $('.fishing-afternoon-pass-content');
        if (fishingContent.length === 0) {
            return; // Abandon this hook if target does not exist
        }

        const bookingForm = $('form.wc-bookings-booking-form');

        // These are visible form fields for choosing a fishing day pass
        const numGuests = $('select#num-guests');
        const addToCart = $('button[name="add-to-cart"]');

        const bookingCost = $('.wc-bookings-booking-cost');

        // These are hidden form fields behind the calendar UI
        const checkInYear = $('input[name="wc_bookings_field_start_date_year"]');
        const checkInMonth = $('input[name="wc_bookings_field_start_date_month"]');
        const checkInDay = $('input[name="wc_bookings_field_start_date_day"]');
        const numPersons = $('input[name="wc_bookings_field_persons"]');

        const setPriceContent = function() {
            $('.cost-container').html(bookingCost.html());
        }

        const handleNumGuestsChange = function() {
            numPersons.attr('value', numGuests.val());
            numPersons.trigger('change');
        }
        numGuests.change(handleNumGuestsChange);

        const setBookingToToday = function() {
            let today = new Date();
            let day = String(today.getDate()).padStart(2, '0');
            let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let year = today.getFullYear();

            checkInYear.attr('value', year);
            checkInMonth.attr('value',month);
            checkInDay.attr('value',day);
        }

        const maybeEnableAddToCart = function() {
            $(document.body).trigger("wc_booking_form_changed");

            if (
                numGuests.val() !== null
            ) {
                addToCart.removeClass('disabled');
            } else {
                addToCart.addClass('disabled');
            }
        };
        numGuests.change(maybeEnableAddToCart);
        addToCart.click(maybeEnableAddToCart);

        const submitForm = function(e) {
            if ($(this).hasClass('disabled')) {
                e.preventDefault();
            }
            bookingForm.submit();
        };
        addToCart.click(submitForm);

        let observer = new MutationObserver(setPriceContent);
        observer.observe(bookingCost[0], {characterData: true, childList: true});

        handleNumGuestsChange();
        setPriceContent();
        setBookingToToday();
        maybeEnableAddToCart();
    });
})(jQuery);